module.exports = __webpack_public_path__ + "img/1970East-073_WEB-min.f2d6c35c.jpg";